module.exports = __webpack_public_path__ + "static/media/Shoes_1.fb8cdabe.jpg";